<template>
   <aside class="main-sidebar">
      <section class="sidebar">
         <div class="user-panel">
            <div class="pull-left image">
               <img src="/assets/img/defaultProPic.png" class="img-circle" alt="User Image">
            </div>
            <div class="pull-left info">
               <p>{{userData.reseller.full_name}}</p>
               <a href="#">
               <i class="fa fa-circle text-success"></i> Online
               </a>
               <router-link :to="{name: 'PaymentReportView'}" style="display: block;margin-top: 10px; color: rgb(189, 30, 44);" title="Current Balance" v-if="com_user_type_access([0,1,5,6,7])">
                  <i :class="balance < 50?'top-i text-danger':'top-i'">
                     <span v-if="balance < 1">VPN Balance(OD):</span>
                     <span v-else>Balance:</span>
                     {{balance}}
                  </i>
               </router-link>
               <!-- <p v-if="com_user_type_access([0,1])" style="font-size: 10px;">VPN Available PIN : {{pinAmount}}</p> -->
               <p :class="userData.reseller.tv_pin_balance < 50?'top-i text-danger':'top-i'" v-if="com_isTVReseller()" style="font-size: 10px;">
                  TV Available PIN : {{userData.reseller.tv_pin_balance}}
               </p>
            </div>
         </div>
         <ul class="sidebar-menu">
            <li :class="DashboardActive==true?'active':''" v-if="com_user_type_access([0,1,2,3,4])">
               <router-link :to="{name: 'Home'}">
                  <i class="ion ion-ios-speedometer"></i>
                  <span>Dashboard</span>
               </router-link>
            </li>
            <li :class="affDashboardActive==true?'active':''" v-if="com_user_type_access([1])">
               <router-link :to="{name: 'HomeAffiliate'}">
                  <i class="ion ion-ios-speedometer"></i>
                  <span>Affiliate Dashboard</span>
               </router-link>
            </li>
            <!-- <li :class="tvDashboardActive==true?'active':''" v-if="com_user_type_access([0,1,2]) && com_isTVReseller()">
               <router-link :to="{name: 'HomeFlex'}">
                  <i class="ion ion-ios-speedometer"></i>
                  <span>{{com_TVOwnerName()}} Dashboard</span>
               </router-link>
            </li> -->
            <li :class="subscriptionActive==true?'treeview active':'treeview'" v-if="com_user_type_access([4])">
               <a href="#">
                  <i class="fa fa-user-circle"></i>
                  <span>Subscriptions</span>
                  <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"></i>
               </span>
               </a>
               <ul class="treeview-menu">
                 <!-- <li>
                     <router-link :to="{name: 'SubscribersList'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Subscribers</span>
                     </router-link>
                  </li>-->
                  <li>
                     <router-link :to="{name: 'SubscriptionCode'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Subscriptions Code</span>
                     </router-link>
                  </li>
                  <li>
                     <router-link :to="{name: 'AddSubscriptionBatchs'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Generate Bulk Subscription</span>
                     </router-link>
                  </li>
                  <li>
                     <router-link :to="{name: 'SubscriptionBatchList'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Bulk Subscription</span>
                     </router-link>
                  </li>
               </ul>
            </li>

            <li :class="clientActive==true?'treeview active':'treeview'" v-if="com_user_type_access([0,1])">
               <a href="#">
               <i class="fa fa-user-circle"></i>
               <span>VPN Client</span>
               <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"></i>
               </span>
               </a>
               <ul class="treeview-menu">
                  <li v-if="reseller_access">
                     <router-link :to="{name: 'ResellerLists'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Resellers</span>
                     </router-link>
                  </li>
                  <li>
                     <router-link :to="{name: 'PinLists'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>VPN Single PIN</span>
                     </router-link>
                  </li>
                  <li v-if="com_user_type_access([0,1], false, [1,4])">
                     <router-link :to="{name: 'AddPinBatchs'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>VPN Generate PIN Batch</span>
                     </router-link>
                  </li>
                  <li v-if="com_user_type_access([0,1], false, [1,4])">
                     <router-link :to="{name: 'PinBatchLists'}">  
                        <i class="ion ion-arrow-right-b"></i>
                        <span>VPN PIN Batch</span>
                     </router-link>
                  </li>
                  <li>
                     <router-link :to="{name: 'ResellerConnectedUsers'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>VPN Connected Users</span>
                     </router-link>
                  </li>
               </ul>
            </li>

            <li :class="clientActive==true?'treeview active':'treeview'" v-if="com_user_type_access([5,6])">
               <a href="#">
               <i class="fa fa-user-circle"></i>
               <span>DNS Client</span>
               <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"></i>
               </span>
               </a>
               <ul class="treeview-menu">
                  <li >
                     <router-link :to="{name: 'DnsLists'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Single Subscriber</span>
                     </router-link>
                  </li>
                  <li>
                     <router-link :to="{name: 'AddDnsBatchs'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Generate DNS Batch</span>
                     </router-link>
                  </li>
                  <li >
                     <router-link :to="{name: 'DnsBatchLists'}">  
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Generate DNS Subscriber Batch</span>
                     </router-link>
                  </li>
               </ul>
            </li>

            <li :class="rateActive==true?'treeview active':'treeview'" v-if="com_user_type_access([0,1,5,6,7])">
               <a href="#">
               <i class="fa fa-calculator"></i><span>VPN Rates</span>
               <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"></i>
               </span>
               </a>
               <ul class="treeview-menu">
                  <li>
                     <router-link :to="{name: 'AddRatePlans'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Add New VPN Rate Plan</span>
                     </router-link>
                  </li>
                  <li>
                     <router-link :to="{name: 'RatePlans'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>VPN Rate Plan</span>
                     </router-link>
                  </li>
                  <li>
                     <router-link :to="{name: 'BaseRatePlans'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>VPN Base Rate Chart</span>
                     </router-link>
                  </li>
               </ul>
            </li>

            <!-- <li :class="flexActive==true?'treeview active tvsection':'treeview tvsection'" v-if="com_isTVReseller()">
               <a href="#">
               <i class="fa fa-tv"></i>
               <span>{{com_TVOwnerName()}}</span>
               <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"></i>
               </span>
               </a>
               <ul class="treeview-menu">
                  <li>
                     <router-link :to="{name: 'FlexResellerLists'}" v-if="userData.reseller4.affiliate_type==3 && userData.reseller4.is_tv_reseller==1">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>TV Resellers</span>
                     </router-link>
                  </li>
                  <li>
                     <router-link :to="{name: 'FlexPinLists'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>TV Single PIN</span>
                     </router-link>
                  </li>
                  <li v-if="com_isTVReseller(true, [393])">
                     <router-link :to="{name: 'FlexAddPinValidityView'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>TV PIN Validity Add</span>
                     </router-link>
                  </li>
                  <li v-if="com_isTVReseller(true, [393,395])">
                     <router-link :to="{name: 'FlexSinglePinActivations'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>TV Online PIN Activation</span>
                     </router-link>
                  </li>
                  <li>
                     <router-link :to="{name: 'FlexPinBatchLists'}">  
                        <i class="ion ion-arrow-right-b"></i>
                        <span>TV PIN Batch</span>
                     </router-link>
                  </li>
                  <li class="report_section"> 
                     <span>Report Section</span>
                  </li>
                  <li v-if="com_isTVReseller(true, [393])">
                     <router-link :to="{name: 'FlexOnlineSubscriptionReport'}">  
                        <i class="ion ion-arrow-right-b"></i>
                        <span>TV Online Subscription Rprt.</span>
                     </router-link>
                  </li>
                  <li v-if="com_isTVReseller(true, [393])">
                     <router-link :to="{name: 'FlexOfflineSubscriptionReport'}">  
                        <i class="ion ion-arrow-right-b"></i>
                        <span>TV Offline Payment PIN Rprt.</span>
                     </router-link>
                  </li>
                  <li v-if="com_isTVReseller(true, [393])">
                     <router-link :to="{name: 'FlexFreePinReportView'}">  
                        <i class="ion ion-arrow-right-b"></i>
                        <span>TV Free Subscription Report</span>
                     </router-link>
                  </li>
                  <li>
                     <router-link :to="{name: 'FlexPinSubscriptionReportView'}">  
                        <i class="ion ion-arrow-right-b"></i>
                        <span>TV PIN Subscription Report</span>
                     </router-link>
                  </li>
                  <li v-if="com_isTVReseller(true, [393])">
                     <router-link :to="{name: 'FlexPinBatchSaleReportView'}">  
                        <i class="ion ion-arrow-right-b"></i>
                        <span>TV PIN Batch Sale Report</span>
                     </router-link>
                  </li>
                  <li>
                     <router-link :to="{name: 'FlexPaymentReportView'}">  
                        <i class="ion ion-arrow-right-b"></i>
                        <span>TV Payment Report</span>
                     </router-link>
                  </li>
                  <li v-if="com_isTVReseller(true, [393])">
                     <router-link :to="{name: 'FlexRechargeReport'}">  
                        <i class="ion ion-arrow-right-b"></i>
                        <span>TV Recharge Report</span>
                     </router-link>
                  </li>
                  <li v-if="com_isTVReseller(true, [393])">
                     <router-link :to="{name: 'FlexPromotionMonitoringReportView'}">  
                        <i class="ion ion-arrow-right-b"></i>
                        <span>TV Promo Monitoring Report</span>
                     </router-link>
                  </li>
               </ul>
            </li> -->

            <li :class="campaignActive==true?'treeview active':'treeview'" v-if="com_user_type_access([1,2])">
               <a href="#">
               <i class="fa fa-globe"></i><span>Campaigns Section</span>
               <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"></i>
               </span>
               </a>
               <ul class="treeview-menu">
                  <li>
                     <router-link :to="{name: 'CampaignLists'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Campaign List</span>
                     </router-link>
                  </li>
                  <li>
                     <router-link :to="{name: 'BillingAccountLists'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Billing Account List</span>
                     </router-link>
                  </li>
                  <li>
                     <router-link :to="{name: 'WithdrawLists'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Withdraw List</span>
                     </router-link>
                  </li>
               </ul>
            </li>

            <li :class="campaignActive==true?'treeview active':'treeview'" v-if="com_Access_CampaignCouponManagement()">
               <a href="#">
               <i class="fa fa-globe"></i><span>Campaign Management</span>
               <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"></i>
               </span>
               </a>
               <ul class="treeview-menu">
                  <li>
                     <router-link :to="{name: 'CampaignCouponList'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Campaign List</span>
                     </router-link>
                  </li>
                  <li>
                     <router-link :to="{name: 'AddCampaignCoupon'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Add New Campaign</span>
                     </router-link>
                  </li>
               </ul>
            </li>

            <li :class="clientActive==true?'treeview active':'treeview'" v-if="com_user_type_access([0,1]) && resellerMenuAccess">
               <a href="#">
               <i class="fa fa-user-circle"></i>
               <span>Push</span>
               <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"></i>
               </span>
               </a>
               <ul class="treeview-menu">
                  <li v-if="reseller_access">
                     <router-link :to="{name: 'SendPush'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Send Push</span>
                     </router-link>
                  </li>
                  <li v-if="reseller_access">
                     <router-link :to="{name: 'AllPushRequests'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>All Push Requests</span>
                     </router-link>
                  </li>
               </ul>
            </li>

            <li :class="clientActive==true?'treeview active':'treeview'" v-if="com_user_type_access([0,1]) && bannerAcessForReseller">
               <a href="#">
               <i class="fa fa-user-circle"></i>
               <span>Banner</span>
               <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"></i>
               </span>
               </a>
               <ul class="treeview-menu">
                  <li v-if="reseller_access">
                     <router-link :to="{name: 'Banners'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Offer & Banners</span>
                     </router-link>
                  </li>
               </ul>
            </li>

            <li :class="reportsActive==true?'treeview active':'treeview'" v-if="com_user_type_access([0,1,2,5,6,7])">
               <a href="#">
               <i class="fa fa-line-chart"></i><span>VPN Reports</span>
               <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"></i>
               </span>
               </a>
               <ul class="treeview-menu">
                  <li v-if="com_user_type_access([0,1,5,6,7])">
                     <router-link :to="{name: 'PinSubscriptionReportView'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>PIN Subscription Report</span>
                     </router-link>
                  </li>
                  <li v-if="com_user_type_access([0,1])">
                     <router-link :to="{name: 'ResellerTransactionReportView'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Transaction Report</span>
                     </router-link>
                  </li>
                  <li v-if="com_user_type_access([0,1,7]) && allowOnlineReport">
                     <router-link :to="{name: 'OnlineTransactionReportView'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Online Transaction Report</span>
                     </router-link>
                  </li>
                  <li v-if="com_user_type_access([0,1 , 5, 6,7])">
                     <router-link :to="{name: 'PaymentReportView'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Payment Report</span>
                     </router-link>
                  </li>
                  <li v-if="com_user_type_access([0,1])">
                     <router-link :to="{name: 'IndividualSoldPinReportView'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Individual Sold PINS</span>
                     </router-link>
                  </li>
                  <li v-if="com_user_type_access([0,1])">
                     <router-link :to="{name: 'HourlySubscriptionReportView'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Hourly Subscription</span>
                     </router-link>
                  </li>

                  <li v-if="com_free_signup_pin_report(this.userData.reseller.id)">
                     <router-link :to="{name: 'FreeSignupPinsReport'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Free Sign Up</span>
                     </router-link>
                  </li>

                  <li v-if="com_user_type_access([1,2])">
                     <router-link :to="{name: 'CampaignSaleReportView'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Campaign Sale</span>
                     </router-link>
                  </li>
               </ul>
            </li>

            <li :class="settingsActive==true?'treeview active':'treeview'" v-if="setting_access && com_user_type_access([0,1])">
               <a href="#">
               <i class="fa fa-cog"></i><span>Settings</span>
               <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"></i>
               </span>
               </a>
               <ul class="treeview-menu">`
                  <li>
                     <router-link :to="{name: 'AddPanelSettings'}">
                        <i class="ion ion-arrow-right-b"></i>
                        <span>Panel</span>
                     </router-link>
                  </li>
               </ul>
            </li>
         </ul>
      </section>
   </aside>
</template>
<script>
   import axios from 'axios'
   export default {
      name: "LeftSideBar",
      data() {
         return {
            userData : {},
            balance : 0,
            pinAmount : 0,
            setting_access : false,
            reseller_access : false,
            resellerMenuAccess : false,
            bannerAcessForReseller : false,
            reportsActive : false,
            rateActive : false,
            clientActive : false,
            settingsActive : false,
            DashboardActive : false,
            affDashboardActive : false,
            tvDashboardActive : false,
            campaignActive : false,
            allowOnlineReport : false,
            flexActive : false,
            subscriptionActive : false,
         };
      },
      created(){
         this.activeInactiveSideBar();
         this.setting_access = this.com_verifyAllowOrNotSetting();

         var rootObject = this;
         var encryptedData = this.$store.getters.getUser;
         var decodedString  = this.com_DecryptString(encryptedData);
         this.updateMenuAccess(decodedString);
         var userData = JSON.parse(decodedString);
         if(userData.user_level !=1){
            this.reseller_access = true;
         }
         
         this.allowOnlineReport = this.com_onlineReportAccess();
         // this.resellerMenuAccess = 
         this.userData = userData;
         var balance = parseInt(userData.reseller.balance * 10000) / 10000;
         this.balance = balance;
         // console.log(this.userData, "hello", this.userData.reseller.dns_rate_plan_id);

         var rateplanid = (this.userData.reseller.affiliate_type === 5 || this.userData.reseller.affiliate_type === 6) ? this.userData.reseller.dns_rate_plan_id : this.userData.reseller.rate_plan_id;
         axios.get('get-rates-by-plan-id/'+rateplanid).then(function (response) {
            rootObject.calculatePinAmount(response.data.rates);
         })
         .catch(function (error) {
            let alertmessage = "";
            for (var prop in error.response.data) {
               alertmessage += ' '+error.response.data[prop]
            }
            console.log(alertmessage);
         });
      },
      methods:{
         updateMenuAccess($userData){
            var userData = JSON.parse($userData);
            if(userData?.id_reseller === 589){
               this.resellerMenuAccess = true;
            }
            if(userData?.id_reseller === 624){
               this.bannerAcessForReseller = true;
            }
         },
         calculatePinAmount(response){
            //console.log(response);
            for (var prop in response) {
               if(response[prop]['no_of_days']==30){
                  this.pinAmount = parseInt(this.balance / response[prop]['price']);
               }
            }
         },

         activeInactiveSideBar(){
            let routeName = this.$route.name;
            if(routeName=='PinSubscriptionReportView' || routeName=='ResellerTransactionReportView' || routeName=='PaymentReportView' || routeName=='IndividualSoldPinReportView' || routeName=='HourlySubscriptionReportView' || routeName=='CampaignSubscriptionReportView' || routeName=='CampaignSaleReportView' || routeName=='OnlineTransactionReportView'){
               this.reportsActive = true;
            }

            if(routeName=='AddRatePlans' || routeName=='RatePlans' || routeName=='BaseRatePlans' || routeName=='EditRatePlans' || routeName=='SaleingRatePlans' || routeName=='EditSaleRates'){
               this.rateActive = true;
            }

            if(routeName=='ResellerLists' || routeName=='PinLists' || routeName=='AddPinBatchs' || routeName=='PinBatchLists' || routeName=='ResellerConnectedUsers' || routeName=='AddNewResellers' || routeName=='EditResellers' || routeName=='AddSinglePins' || routeName=='EditBatchs' || routeName=='PinListBatchWises'){
               this.clientActive = true;
            }

            if(routeName=='AddPanelSettings'){
               this.settingsActive = true;
            }

            this.DashboardActive = false;
            if(routeName=='Home'){
               this.DashboardActive = true;
            }

            if(routeName=='HomeAffiliate'){
               this.affDashboardActive = true;
            }

            if(routeName=='HomeFlex'){
               this.tvDashboardActive = true;
            }

            if(routeName=='CampaignLists' || routeName=='AddBillingAccounts' || routeName=='BillingAccountLists' || routeName=='WithdrawLists' || routeName=='AddNewWithdrawals'){
               this.campaignActive = true;
            }

            if(routeName=='FlexPinLists' || routeName=='FlexAddSinglePins' || routeName=='FlexAddPinBatchs' || routeName=='FlexPinBatchLists' || routeName=='FlexPinSubscriptionReportView' || routeName=='FlexPaymentReportView' || routeName=='FlexResellerLists' || routeName=='FlexSinglePinActivations'|| routeName=='FlexFreePinReportView' || routeName=='FlexPromotionMonitoringReportView' || routeName=='FlexPinBatchSaleReportView' || routeName=='FlexOnlineSubscriptionReport' || routeName=='FlexOfflineSubscriptionReport' || routeName=='FlexRechargeReport' || routeName=='FlexAddPinValidityView'){
               this.flexActive = true;
            }

            if(routeName=='SubscriptionCode' || routeName=='SubscribersList' || routeName=='AddSubscriptionCode' || routeName=='AddSubscriptionBatchs' || routeName=='SubscriptionBatchList'){
               this.subscriptionActive = true;
            }
            
         }
      },
      computed: {
       
      },
      mounted: function() {
         var rootObj = this;
         $('body').on("click","#cboxClose", function(){
            if(rootObj.$route.name != "FlexPinLists"){
               rootObj.$router.push('tvpinlist');
               $('.tvsection').addClass('active');
               $('.tvsection ul').addClass('menu-open');
            }
         });
      }
   };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   .report_section{
      padding-left: 35px;
      font-size: 12px;
      background-color: #cfd3d8;
      padding-top: 5px;
      padding-bottom: 5px;
      margin-right: 5px !important;
      font-weight: bold;
      border-radius: 5px;
   }
</style>